export const MODULE_PATH = "vehicles";

export const INDEX = `/s/${MODULE_PATH}`;
export const INDEX_HOME = `/s/${MODULE_PATH}/home`;

export const MAP = `/s/${MODULE_PATH}/map`;

export const VEHICLES = `/s/${MODULE_PATH}/vehicles`;
export const VEHICLES_DETAIL = `/s/${MODULE_PATH}/vehicles/detail`;

export const VEHICLES_OWNERS = `/s/${MODULE_PATH}/vehicles/form`;
export const VEHICLES_FORM_TYPES = `/s/${MODULE_PATH}/vehicles/form/types`;

export const VEHICLES_TRANSFER = `/s/${MODULE_PATH}/vehicles/transfer`;

export const MODEL_LIST = `/s/${MODULE_PATH}/models`;
export const VEHICLES_MODEL_FORM = `/s/${MODULE_PATH}/models/form`;
export const MODEL_DETAIL = `/s/${MODULE_PATH}/models/detail`;

export const RATE_DETAIL = `/s/owners/rates/detail`;

export const CONTRACTS = `/s/${MODULE_PATH}/contracts`;
export const CONTRACTS_DETAIL = `/s/${MODULE_PATH}/contracts/detail`;

export const BOOKINGS = `/s/${MODULE_PATH}/bookings`;
export const BOOKINGS_TIMELINE = `/s/${MODULE_PATH}/bookings/timeline`;
export const BOOKINGS_OPERATIONS = `/s/${MODULE_PATH}/bookings/operations`;
export const BOOKINGS_DELIVERIES = `/s/${MODULE_PATH}/bookings/deliveries`;
export const BOOKINGS_RETURNS = `/s/${MODULE_PATH}/bookings/returns`;
export const BOOKINGS_FORM = `/s/${MODULE_PATH}/bookings/form`;
export const BOOKINGS_CHECKIN = `/s/${MODULE_PATH}/bookings/checkin`;
export const BOOKINGS_OPERATION_PROCESSING = `/s/${MODULE_PATH}/bookings/operation/processing`;

export const TIMELINE = `/s/${MODULE_PATH}/timeline`;
export const TIMELINE_CREATE_OPERATION = `/s/${MODULE_PATH}/timeline?createOperation=true`;

export const SUBSCRIPTIONS = `/s/${MODULE_PATH}/subscriptions`;
export const SUBSCRIPTIONS_REQUESTS = `/s/${MODULE_PATH}/subscriptions/requests`;
export const SUBSCRIPTIONS_DELIVERIES = `/s/${MODULE_PATH}/subscriptions/deliveries`;
export const SUBSCRIPTIONS_RETURNS = `/s/${MODULE_PATH}/subscriptions/returns`;
export const SUBSCRIPTIONS_EXPIRED = `/s/${MODULE_PATH}/subscriptions/expired`;
export const SUBSCRIPTIONS_EXCEEDED_KM = `/s/${MODULE_PATH}/subscriptions/exceeded`;

export const CATEGORY_LIST = `/s/${MODULE_PATH}/category`;
export const CATEGORY_FORM = `/s/${MODULE_PATH}/category/form`;
export const CATEGORY_DETAIL = `/s/${MODULE_PATH}/category/detail`;

export const SUBSCRIPTION_FORM = `/s/${MODULE_PATH}/subscription/form`;

export const BUDGETS_LIST = `/s/${MODULE_PATH}/budgets`;
export const BUDGETS_TYPES = `/s/${MODULE_PATH}/budgets/form`;
export const BUDGETS_DETAIL = `/s/${MODULE_PATH}/budgets/detail`;

export const SEASONS_LIST = `/s/${MODULE_PATH}/seasons`;
export const SEASONS_FORM = `/s/${MODULE_PATH}/seasons/form`;
export const SEASONS_DETAIL = `/s/${MODULE_PATH}/seasons/detail`;

export const GROUP_SEATS_LIST = `/s/${MODULE_PATH}/groupSeats`;
export const GROUP_SEATS_FORM = `/s/${MODULE_PATH}/groupSeats/form`;
export const GROUP_SEATS_DETAIL = `/s/${MODULE_PATH}/groupSeats/detail`;

export const EXPENSES_LIST = `/s/${MODULE_PATH}/expenses`;
export const EXPENSES_DETAIL = `/s/${MODULE_PATH}/expenses/detail`;
